
import { InstantSearch, SearchBox } from 'react-instantsearch-dom';
import MoviesHits from './components/moviesHits';
import "./searchbox.css"
import { searchClient } from '../../typesenseAdapter';
import Arrow from "../../assets/SettingsPage/SVG/Arrow 1.svg";
import { useNavigate } from 'react-router-dom';


function SearchPage() {

  const navigate = useNavigate()
  const navigatorfun = () => {
    navigate("/home");
  }


  return (
    <>
      <div
        className="flex mt-[20px] ml-[20px]"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          className="w-[40x] cursor-pointer"
          onClick={() => {
            navigatorfun()
          }}
        >
          <img src={Arrow} />
        </div>

      </div>
      <InstantSearch indexName="Users" searchClient={searchClient}>
        <SearchBox translations={{ placeholder: " Search here" }} />
        <MoviesHits />
      </InstantSearch>
    </>

  )

}

export default SearchPage